import dashboardStyle from "../styles/Dashboard.module.css";
import { getPaymentInformation, getGetnetLink } from "../services/api";
import logoPng from "../images/Frame.png";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useDataContext } from "../contexts/AuthContext";

export default function ModalConfirmarItems({
  handleAceptar,
  handleCancelar,
  userDebtsWithStyles,
}) {
  const { contextData } = useDataContext();
  const [paymentMethod, setPaymentMethod] = useState("");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [getnetLink, setGetnetLink] = useState(null);

  useEffect(() => {
    getPaymentInformation(contextData.customer.id, contextData.customer.order_id)
      .then((data) => {
        setPaymentMethod(data.payment_method);
        setItems(data.items);
        setLoading(false);
      })
      .catch((error) => {
        console.log("Error en la solicitud de información de pago", error);
      });
  }, [contextData.customer.id, contextData.customer.order_id]);

  // Tarjeta de crédito → link GetNet que coincide con la selección.
  useEffect(() => {
    if (!String(paymentMethod || "").toLowerCase().includes("tarjeta")) {
      setGetnetLink(null);
      return;
    }
    getGetnetLink(contextData.customer.id, contextData.customer.order_id)
      .then((data) => setGetnetLink(data?.link || null))
      .catch((e) => console.error("No se pudo obtener el link GetNet:", e));
  }, [paymentMethod, contextData.customer.id, contextData.customer.order_id]);

  const copiarLink = () => {
    if (!getnetLink?.url) return;
    const done = () =>
      Swal.fire({ icon: "success", iconColor: "#22c55e", title: "Link copiado", text: "Pegalo en tu navegador para pagar con tarjeta.", confirmButtonColor: "#0071ce" });
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(getnetLink.url).then(done).catch(() =>
        Swal.fire({ icon: "info", title: "Link de pago", html: `<code style="word-break:break-all;font-size:.8em">${getnetLink.url}</code>`, confirmButtonColor: "#0071ce" })
      );
    } else {
      Swal.fire({ icon: "info", title: "Link de pago", html: `<code style="word-break:break-all;font-size:.8em">${getnetLink.url}</code>`, confirmButtonColor: "#0071ce" });
    }
  };

  const totalCuotas = userDebtsWithStyles.length;
  return (
    <>
      {loading ? (
        <div className="contcargando">
          <img src={logoPng} alt="littleBlueLogo" className="imgcargando" />
          <h2 className="text-muted">CARGANDO...</h2>
          <div className="loader"></div>
        </div>
      ) : (
        <div className={dashboardStyle.modalBackground}>
          <div className={dashboardStyle.modal}>
            <div className={dashboardStyle.modalHeader}>
              <h2 className={dashboardStyle.modalTitle}>
                Prendas y <span className={dashboardStyle.modalTitleAccent}>método</span>{" "}
                de pago seleccionado
              </h2>
              <p className={dashboardStyle.modalSubtitle}>
                Revisá la selección antes de confirmarla.
              </p>
            </div>

            <div className={dashboardStyle.modalSummarySection}>
              <span className={dashboardStyle.modalSummaryLabel}>
                Prendas seleccionadas
              </span>
              {items.map((item, index) => (
                <div key={index} className={dashboardStyle.modalSummaryRow}>
                  <span className={dashboardStyle.modalSummaryItem}>
                    {item.name}
                    {item.alias && item.alias !== item.name ? ` ${item.alias}` : ""}
                  </span>
                  <span className={dashboardStyle.modalSummaryQty}>
                    Cantidad: {item.quantity}
                  </span>
                </div>
              ))}
            </div>

            <div className={dashboardStyle.modalSummarySection}>
              <span className={dashboardStyle.modalSummaryLabel}>
                Método de pago
              </span>
              <span className={dashboardStyle.modalSummaryMethod}>
                {paymentMethod}
              </span>
              <span className={dashboardStyle.modalSummaryCuotas}>
                Total de cuotas: {totalCuotas}
              </span>
              {String(paymentMethod || "").toLowerCase().includes("tarjeta") && (
                getnetLink && getnetLink.url ? (
                  <div style={{ display: "flex", gap: ".5em", flexWrap: "wrap", marginTop: ".6em" }}>
                    <a
                      href={getnetLink.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ flex: 1, minWidth: "9em", textAlign: "center", textDecoration: "none", borderRadius: ".7em", background: "#0071ce", color: "#fff", padding: ".6em .8em", fontWeight: 800, fontSize: ".85em" }}
                    >
                      <i className="bi bi-credit-card-2-front-fill" /> Pagar con tarjeta
                    </a>
                    <button
                      type="button"
                      onClick={copiarLink}
                      style={{ flex: "0 0 auto", border: "1.5px solid #0071ce", background: "#fff", color: "#0071ce", borderRadius: ".7em", padding: ".6em .8em", fontWeight: 700, fontSize: ".85em", cursor: "pointer" }}
                    >
                      <i className="bi bi-clipboard" /> Copiar link
                    </button>
                  </div>
                ) : (
                  <p style={{ marginTop: ".6em", padding: ".6em .8em", borderRadius: ".7em", background: "#fff7ed", color: "#9a3412", fontSize: ".82em", border: "1px solid #fed7aa" }}>
                    <i className="bi bi-info-circle" /> Solicitá el link de pago a tu asesor.
                  </p>
                )
              )}
            </div>

            <div className={dashboardStyle.modalFooter}>
              <button
                className={dashboardStyle.btnOutline}
                type="button"
                onClick={handleCancelar}
              >
                Modificar
              </button>
              <button
                className={dashboardStyle.btnPrimary}
                type="button"
                onClick={handleAceptar}
              >
                Confirmar
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
